import { StepSuccessfulAside } from './StepSuccessfulAside';

export const Successful = ({ isSuccessful }) => (
  <>
    <div className="mx-auto lg:mx-0 lg:flex">
      <div className="hidden lg:block lg:w-5/12 2xl:w-5/12 h-screen">
        <div className={`bg-[#006EB7] h-full ${isSuccessful ? 'relative overflow-hidden' : ''}`}>
          <StepSuccessfulAside />
          <p className="text-white text-center font-450 text-base -mt-4">
            Having trouble? <a href="/professionals/contact-us" className="underline font-semibold">Contact us here</a>
          </p>
        </div>
      </div>
      <div className="lg:w-7/12 lg:flex lg:items-center lg:h-screen">
        <div className="w-full py-10 container mx-auto px-6 md:px-20 xl:px-36 lg:px-24 text-center pt-36 lg:pt-0">
          <h2 className="text-[#0C0D1A] text-3xl md:text-4xl font-medium lg:font-semibold lg:mb-8">Thank you!</h2>
          <p className="text-[#373945] text-base font-medium mb-6 lg:hidden">Your registration has been submitted, we will be in touch shortly.</p>

          <div className="mb-6 p-6 bg-[#F3F4F8] bg-opacity-75 rounded-lg flex flex-col items-center lg:items-start">
            <div className="flex gap-2 mb-2 justify-center lg:justify-start">
              <img src="/img/icons/key-01.svg" className="w-6 h-6" alt="Key info" />
              <span className="text-[#373945] text-base font-semibold">Watch for a Password in your Inbox</span>
            </div>

            <p className="text-[#373945] text-sm font-medium text-center lg:text-left">
              You&#39;ll receive a secure password and login instructions as soon as our verification checks are complete.
            </p>
          </div>

          <p className="text-[#007DD1] text-base font-450">Return to our main website <a href="/professionals" className="plain-text-link plain-text-link--underline" aria-label="Return to our main website">here</a></p>
        </div>
      </div>
    </div>
  </>
);
